import { action } from 'mobx';

export interface IStepIndicatorProps {
  stepList: Readonly<string[]>;
  currentStep: string;
}

export class StepIndicatorVM {
  // returns a string of class names for a general progress bar
  // given a current step, the step to get classes for (thisStep), and an array of steps
  @action.bound getClassNames(currentStep, thisStep, stepList) {
    const result =
      'py-2 header-links' +
      (currentStep === thisStep ? ' active' : '') +
      (stepList.indexOf(currentStep) > stepList.indexOf(thisStep) ? ' complete' : ' ');
    return result;
  }
  // Same thing but for mobile/tablet view
  @action.bound getClassNamesMobile(currentStep, thisStep, stepList) {
    const result =
      'usa-step-indicator__segment' +
      (currentStep === thisStep ? '  usa-step-indicator__segment--current' : '') +
      (stepList.indexOf(currentStep) > stepList.indexOf(thisStep) ? '  usa-step-indicator__segment--complete' : ' ');
    return result;
  }
  @action.bound getCurrentStatus(currentStep, stepList) {
    const status = 'Step ' + (stepList.indexOf(currentStep) + 1) + ' of ' + stepList.length + ' ' + currentStep;
    return status;
  }
}
